var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h4',{staticClass:"pt-3"},[_vm._v(_vm._s(_vm.$t('weHaveProblem'))+"!")]),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('pageUnavailable'))+".")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }